<template>
  <v-dialog
    v-if="show"
    v-model="dialog"
    light
    scrollable
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        icon
        large
        :disabled="disabled"
      >
        <v-icon v-text="icons.moreVertical" />
      </v-btn>
    </template>
    <v-card>
      <v-toolbar
        flat
        dense
        color="grey lighten-4"
        class="text-h6"
      >
        <v-toolbar-title v-text="__('paymentMethod')" />
        <v-spacer />
        <v-btn
          icon
          color="primary"
          @click="dialog = false"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0">
        <v-list>
          <v-list-item
            v-for="paymentMethod in paymentMethods"
            :key="paymentMethod.id"
            :disabled="PaymentMethod.isDisabled(paymentMethod)"
            @click="select(paymentMethod.id)"
          >
            <v-list-item-title v-text="paymentMethod.name" />
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import PaymentMethod from '@/Models/Static/PaymentMethod'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      paymentMethods: {
        required: true,
        type: Array,
      },
    },

    data: () => ({
      PaymentMethod,
      dialog: false,
    }),

    computed: {
      show () {
        return this.paymentMethods.length > 0
      },
    },

    methods: {
      select (id) {
        this.$emit('select', id)
        this.dialog = false
      },
    },
  }
</script>
